import React from "react";
import Button from "@mui/material/Button";
import LoadingIndicator from "../Loading/LoadingIndicator";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";

const CustomButton = ({
  sx,
  variant,
  children,
  type,
  loading,
  disabled,
  fullWidth,
  onClick,
  form,
  color,
  to,
  icon, // New prop for SVG icon
  ...props
}) => {
  const buttonClickHandler = (e) => {
    onClick && onClick(e);
  };

  const ButtonComponent = (
    <Button
      color={color || "primary"}
      type={type || "button"}
      variant={variant || "contained"}
      sx={{
        py: 1.5,
        px: 3,
        ...(props.href && {
          "&.MuiButtonBase-root:not(:hover)": {
            color: "#ffffff",
          },
          "&.MuiButtonBase-root:hover": {
            color: "#194049",
          },
        }),
        ...sx,
      }}
      target={props.target}
      size="large"
      disabled={!!(loading || disabled)}
      onClick={buttonClickHandler}
      fullWidth={fullWidth}
      disableElevation
      startIcon={loading ? null : props.startIcon}
      form={form}
      {...props}
      endIcon={icon ? <span style={{ marginLeft: 8 }}>{icon}</span> : null}
    >
      {loading ? <LoadingIndicator /> : children}
    </Button>
  );

  return to ? (
    <Link to={to} style={{ textDecoration: "none" }}>
      {ButtonComponent}
    </Link>
  ) : (
    ButtonComponent
  );
  // return ButtonComponent;
};

export default CustomButton;
